function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "FontAwsome_envelope_",
  "data-name": "FontAwsome (envelope)",
  d: "M71.066,64H7.352A7.352,7.352,0,0,0,0,71.352v44.11a7.352,7.352,0,0,0,7.352,7.352H71.066a7.352,7.352,0,0,0,7.352-7.352V71.352A7.352,7.352,0,0,0,71.066,64Zm0,7.352V77.6c-3.434,2.8-8.909,7.145-20.613,16.31-2.579,2.029-7.689,6.9-11.244,6.846-3.555.057-8.666-4.818-11.244-6.846C16.263,84.748,10.786,80.4,7.352,77.6v-6.25ZM7.352,115.462V87.035c3.51,2.8,8.486,6.718,16.072,12.658,3.348,2.635,9.21,8.452,15.785,8.417,6.543.035,12.331-5.7,15.784-8.416,7.586-5.94,12.564-9.864,16.074-12.659v28.427Z",
  transform: "translate(0 -64)",
  fill: "#ac1ede"
});

var SvgFaMail = function SvgFaMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78.418,
    height: 58.813,
    viewBox: "0 0 78.418 58.813",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/faMail.ec5a92c6.svg";
export { ForwardRef as ReactComponent };